import { useLazyGetAllTagsQuery } from '../../../../../../../services/cellcast'
import { useGetTagsMutation } from '../../../../../../../services/cellcast.v3'
import { GetCurrentData } from '../../../../../../Utils/_helpers/GetCurrentData'
import { defaultRegion } from '../../../../../../../_metronic/helpers';

export function useListTag() {
  const currentUser = GetCurrentData();

  const [fetchTagsDataDefault, { data: tagsData }] = useLazyGetAllTagsQuery()
  const [fetchTagsDataRegion, { data: tagsDataRegion }] = useGetTagsMutation()

  const fetchTagsData = (param: any) => {
    if (currentUser?.region === defaultRegion) {
      fetchTagsDataDefault(param)
    } else {
      fetchTagsDataRegion({
        action: 'find_tag',
        data: {
          page: 1,
          limit: 100
        }
      })
    }
  }

  return {
    fetchTagsData,
    data: currentUser?.region === defaultRegion ? tagsData : { data: tagsDataRegion?.data?.items ?? [] }
  }
}
